



























































































































































































































































































































































































































































































































































import { mapActions, mapGetters } from 'vuex';
import { cloneDeep, isEqual } from 'lodash';
import moment from 'moment';
import mixins from '@/utils/mixins';
import { AxiosError } from 'axios';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePayment,
  InventoryAdvancePaymentLine,
  InventoryAdvancePaymentFieldError,
  Vendor,
  InventoryAdvancePaymentSupplierAddress,
  IInventoryAdvancePaymentSupplierAddressData,
  IInventoryAdvancePaymentSupplierAddress,
  IInventoryAdvancePaymentSupplierContactData,
  InventoryAdvancePaymentSupplierContact,
  IInventoryAdvancePaymentSupplierContact,
  InventoryAdvancePaymentSupplier,
  IInventoryAdvancePaymentAttachment,
  Currency,
  Country,
  InventoryAdvancePaymentPaymentType
} from '@/models';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';
import { diffDeep, scrollToBottomOfHtmlElement } from '@/utils/helpers';

import InventoryAdvancePaymentDetailFormLineCard from '@/components/inventory-advance-payment/InventoryAdvancePaymentDetailFormLineCard.vue';
import VendorSearch from '@/components/vendor/VendorSearch.vue';
import CountryPicker from '../common/CountryPicker.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import auth from '@/mixins/auth';
import ALDialog from '../core/Dialog/ALDialog.vue';
import InventoryAdvancePaymentAttachmentListItem from './InventoryAdvancePaymentAttachmentListItem.vue';
import InventoryAdvancePaymentStatusDisplay from '@/components/requisition-common/InventoryAdvancePaymentStatusDisplay.vue';

const baseMixins = mixins(auth);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'InventoryAdvancePaymentDetailFormDialog',

    components: {
      InventoryAdvancePaymentDetailFormLineCard,
      VendorSearch,
      CountryPicker,
      DragDropFileInput,
      ConfirmationDialog,
      ErrorAlert,
      ALDialog,
      InventoryAdvancePaymentAttachmentListItem,
      InventoryAdvancePaymentStatusDisplay
    },

    data: () => ({
      inventoryAdvancePaymentFormValid: true,
      loading: false,
      isEdit: false,
      dialog: false,
      currencyLoading: false,
      departmentLoading: false,
      glAccountsLoading: false,
      dateMenu: false,
      isDragOver: false,
      confirmDialog: false,

      inventoryAdvancePaymentOriginalCopy: null as null | IInventoryAdvancePayment,
      inventoryAdvancePayment: null as null | IInventoryAdvancePayment,
      fieldError: new InventoryAdvancePaymentFieldError(),

      paymentOptions: [
        { type: 'Cash', payment: InventoryAdvancePaymentPaymentType.CASH },
        { type: 'Card', payment: InventoryAdvancePaymentPaymentType.CARD },
        { type: 'Cheque', payment: InventoryAdvancePaymentPaymentType.CHEQUE },
        { type: 'Wire', payment: InventoryAdvancePaymentPaymentType.WIRE }
      ],

      inventoryAdvancePaymentSupplierName: '',
      errorMessage: '',
      errorMessageDetail: ''
    }),

    mounted() {
      // fetch all currencies
      this.currencyLoading = true;
      this.fetchCurrencies()
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          this.fieldError.currency.push('Error occurred getting currencies');
        })
        .finally(() => (this.currencyLoading = false));

      // fetch all departments
      this.departmentLoading = true;
      this.fetchDepartments()
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.departmentLoading = false));

      // fetch all GL Accounts
      this.glAccountsLoading = true;
      this.fetchGLAccounts()
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.glAccountsLoading = false));
    },

    computed: {
      ...mapGetters({
        accounts: 'accounting/getGLAccounts',
        currencies: 'currencyNew/getCurrencies',
        getCurrencyByCode: 'currencyNew/getCurrencyByCode',
        departments: 'department/getDepartments'
      }),

      errorOccurred(): boolean {
        return this.errorMessage.length > 0;
      },

      disableAddressFields(): boolean {
        return this.inventoryAdvancePaymentSupplierName.length == 0;
      },

      disableCurrencyField(): boolean {
        return !!this.inventoryAdvancePayment!.supplier!.vendor_code;
      }
    },

    watch: {
      'inventoryAdvancePayment.supplier.vendor_code': {
        handler(value) {
          if (value) {
            //clear supplier name field if a vendor is selected
            this.inventoryAdvancePaymentSupplierName = '';
          }
        }
      },
      inventoryAdvancePaymentSupplierName: {
        handler(value) {
          if (value && this.inventoryAdvancePayment!.supplier!.vendor_code) {
            //clear selected supplier search field if a vendor is manually inputted
            this.inventoryAdvancePayment!.supplier!.vendor_code! = '';
            this.clearRequitionSupplierAddress();
          }
        }
      }
    },

    methods: {
      ...mapActions({
        fetchGLAccounts: 'accounting/fetchGLAccounts',
        fetchCurrencies: 'currencyNew/fetchCurrencies',
        fetchDepartments: 'department/fetchDepartments',
        createInventoryAdvancePayment:
          'inventoryAdvancePayment/createInventoryAdvancePayment',
        updateInventoryAdvancePayment:
          'inventoryAdvancePayment/updateInventoryAdvancePayment',
        deleteInventoryAdvancePaymentAttachment:
          'inventoryAdvancePayment/deleteInventoryAdvancePaymentAttachment'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(
        inventoryAdvancePayment: IInventoryAdvancePayment = new InventoryAdvancePayment(),
        isEdit = false
      ) {
        this.inventoryAdvancePaymentOriginalCopy = inventoryAdvancePayment;
        this.inventoryAdvancePayment = cloneDeep(
          this.inventoryAdvancePaymentOriginalCopy
        );

        if (!this.inventoryAdvancePayment!.supplier!.vendor_code) {
          this.inventoryAdvancePaymentSupplierName = this.inventoryAdvancePayment.supplier!.name!;
        }

        this.isEdit = isEdit;
        this.clearAllErrors();
        this.dialog = true;

        this.resetFormValidation();
      },

      close() {
        if (
          !isEqual(
            this.inventoryAdvancePayment,
            this.inventoryAdvancePaymentOriginalCopy
          ) &&
          this.isEdit
        ) {
          this.confirmDialog = true;
        } else {
          this.closeDialog();
        }
      },

      formatDate(date: string): string {
        return date ? moment(date).format('MMMM D YYYY') : '';
      },

      allowedDates: (val: string) => {
        return moment(val).isSameOrAfter(new Date(), 'day');
      },

      clearRequitionSupplierAddress() {
        this.inventoryAdvancePayment!.supplier!.address = new InventoryAdvancePaymentSupplierAddress();
      },

      setRequitionSupplierAddress(vendor: Vendor): void {
        if (vendor) {
          this.clearAllErrors();

          const vendorSupplierContactData: IInventoryAdvancePaymentSupplierContactData = {
            name: vendor.contact,
            email: vendor?.email,
            phone: vendor?.phone
          };

          const vendorSupplierAddressData: IInventoryAdvancePaymentSupplierAddressData = {
            address1: vendor.address1,
            address2: vendor.address2,
            city: vendor.city,
            region: vendor.region,
            postal_code: vendor.postal_code,
            country: (vendor.country as Country).code
          };

          const supplierAddress: IInventoryAdvancePaymentSupplierAddress = new InventoryAdvancePaymentSupplierAddress(
            vendorSupplierAddressData
          );
          const supplierContact: IInventoryAdvancePaymentSupplierContact = new InventoryAdvancePaymentSupplierContact(
            vendorSupplierContactData
          );

          const supplier = new InventoryAdvancePaymentSupplier({
            name: vendor.name,
            vendor_code: vendor.id,
            address:
              supplierAddress ??
              this.inventoryAdvancePayment?.supplier?.address,
            contact:
              supplierContact ?? new InventoryAdvancePaymentSupplierContact()
          });

          this.inventoryAdvancePayment!.supplier = supplier;

          const currency: Currency = this.getCurrencyByCode(vendor.currency);
          if (currency) {
            this.inventoryAdvancePayment!.currency = currency.id;
          }
        }
      },

      async addInventoryAdvancePaymentAttachments(file: File | File[]) {
        this.clearAllErrors();
        const fileList = file && Array.isArray(file) ? file : [file];
        fileList.forEach(file => {
          this.inventoryAdvancePayment?.attachFile(file);
        });
        this.$nextTick(() => {
          scrollToBottomOfHtmlElement('#scrollableAttachmentList');
        });
      },

      async removeInventoryAdvancePaymentAttachment(
        attachment: IInventoryAdvancePaymentAttachment
      ) {
        if (attachment.id) {
          await this.deleteInventoryAdvancePaymentAttachment({
            inventoryAdvancePaymentId: this.inventoryAdvancePayment?.id,
            attachmentId: attachment.id
          }).catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          });
        }
        this.inventoryAdvancePayment?.detachFile(attachment.file as File);
      },

      addLine(): void {
        this.inventoryAdvancePayment!.addLine(
          new InventoryAdvancePaymentLine()
        );
      },

      deleteLine(line: number): void {
        const index = line - 1;
        this.inventoryAdvancePayment!.removeLine(index);
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      clearSupplierContactErrors(): void {
        if (this.fieldError.supplier && this.fieldError.supplier.contact) {
          this.fieldError.supplier.contact.clearErrors();
        }
      },

      clearFinancePaymentRequisitiionDetails() {
        this.inventoryAdvancePayment!.note = '';
        this.inventoryAdvancePayment!.reason = '';
      },

      closeDialog() {
        this.closeConfirmDialog();
        this.dialog = false;
      },

      closeConfirmDialog() {
        this.confirmDialog = false;
      },

      async saveInventoryAdvancePayment(): Promise<void> {
        if (this.validateForm()) {
          this.confirmDialog = false;

          this.clearAllErrors();

          this.loading = true;

          if (this.inventoryAdvancePaymentSupplierName) {
            this.inventoryAdvancePayment!.supplier!.name! = this.inventoryAdvancePaymentSupplierName;
          }

          if (!this.inventoryAdvancePayment?.is_provide_payment_detail) {
            this.clearFinancePaymentRequisitiionDetails();
          }

          try {
            if (this.isEdit) {
              const inventoryAdvancePaymentDelta = diffDeep(
                this.inventoryAdvancePayment,
                this.inventoryAdvancePaymentOriginalCopy,
                true
              );
              inventoryAdvancePaymentDelta!.id = this.inventoryAdvancePayment!.id;
              await this.updateInventoryAdvancePayment(
                inventoryAdvancePaymentDelta
              );
            } else {
              await this.createInventoryAdvancePayment(
                this.inventoryAdvancePayment
              );
            }

            // emit success
            this.$emit('success');
            // bypass close dialog checks
            this.dialog = false;
          } catch (err) {
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessage = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                InventoryAdvancePaymentFieldError.isInventoryAdvancePaymentFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new InventoryAdvancePaymentFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          } finally {
            this.loading = false;
          }
        }
      }
    }
  });
